import { render, staticRenderFns } from "./orderSchedule.vue?vue&type=template&id=98a7667a&scoped=true"
import script from "./orderSchedule.vue?vue&type=script&lang=js"
export * from "./orderSchedule.vue?vue&type=script&lang=js"
import style0 from "./orderSchedule.vue?vue&type=style&index=0&id=98a7667a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a7667a",
  null
  
)

export default component.exports